import type { FaireProductEntity } from "../../entity_types/product";

export const p_bnjkzqmazs: FaireProductEntity = {
  token: "p_bnjkzqmazs",
  type: "product",
  name: "Haribo Pasta Penne Sauer 160g (Germany)",
  brandToken: "b_s2gzfhxg44",
  brandName: "Global Bite Co",
  imageUrl:
    "https://cdn.faire.com/fastly/d055eaa07edb2a89fd51c546bc54cfe30011317ace30e41c013a91b8c894df9f.jpeg",
  galleryImageUrls: [],
  priceDollars: 4,
  description:
    "Get ready to pucker up with Haribo Pasta Penne Sauer (160g) — an imported German treat bursting with tangy excitement! These vegan, fruit-flavored gummies are shaped like mini penne noodles and coated in a sour sugar layer for an electrifying bite. Perfect for flavor adventurers craving an exotic snack, they deliver bold colors and intense taste in every piece. Ideal for sharing, snacking, or savoring solo!\n",
  tags: [],
  msrpDollars: 7.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:15.268Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
